<template>
	<div class="crud-form-group" :class="validationRules ? getValidationClass() : ''">
		<CrudLabel
			:label="label"
			:hasCheckBox="hasCheckBox"
			:checkboxData="checkboxData"
			v-if="showLabel"
			:classList="classList"
		/>
		<div class="dropdown-container" :id="id">
			<div class="dropdown-activator" :class="activatorClass" @click="toggleSelect">
				<span class="select-label" :class="!selectedOption ? 'placeholder' : ''">
					{{  !selectedOption ? placeholder : selectedOption.label }}
				</span>
				<span class="arrow" ref="dropArrow">
					<img src="@/drc/assets/icons/arrow-down-white.svg" alt="Dropdwon">
				</span>
			</div>
			<div class="options-container">
				<div class="dropdown-options" ref="optionContainer">
					<div class="option no-check" v-for="(option, index) in optionsList" :key="index" @click="selectOption(index)">
						<span class="option-text">{{ option.label }}</span>
					</div>
				</div>
			</div>
		</div>
		<ErrorList :errors="errors" v-if="errors.length" :classList="errorsClassList" />
		<ErrorList :errors="parentErrors" v-if="parentErrors.length" :classList="errorsClassList" />

	</div>
</template>
<script>
	import ErrorList from "./ErrorList.vue";
	import CrudLabel from "./CrudLabel.vue";
	import { CRUD_SELECT_PROPS } from "./props/CrudSelectProps.js";
	import * as VALIDATION_SERVICE from "@/drc/services/validation.service.js";
	import {EventManagementContent, EventStepFrom} from "@/common/configurations/event-bus.js";

	export default {
		name: "CurdSelect",
		components: {
			CrudLabel,
			ErrorList
		},
		props: {
			...CRUD_SELECT_PROPS
		},
		data() {
			return {
				selectedOption: null,
				errors: [],
				parentErrors: [],
				hasError: false,
				localOptions: []
			}
		},
		methods: {
			getValidationClass() {
				if (this.isManagementListener) {
					return 'auto-validate-mc';
				} else {
					return 'auto-validate';
				}
			},
			toggleSelect() {
				if (!this.isDisabled) {
					if (!this.$refs.dropArrow.classList.contains('active')) {
						this.$refs.optionContainer.style.maxHeight = "200px";
						this.$refs.dropArrow.classList.add('active');
					} else {
						this.$refs.optionContainer.style.maxHeight = "0";
						this.$refs.dropArrow.classList.remove('active');
					}
				}
			},
			checkClick() {
				if (!event.target.closest(`.dropdown-container#${this.id}`)) {
					this.closeDropdown();
				}
			},
			closeDropdown() {
				if (this.$refs.optionContainer.style.maxHeight && this.$refs.optionContainer.style.maxHeight != '0px') {
					this.$refs.optionContainer.style.maxHeight = "0";
					this.$refs.dropArrow.classList.remove('active');
					this.validateField();
				}
			},
			selectOption(index) {
				let selectOption = this.optionsList[index];
				this.selectedOption = selectOption;
				this.toggleOptionStatus(selectOption);
				this.closeDropdown()
				this.$emit('valueHasChanged', {
					fieldName: this.name,
					value: selectOption.id
				});
			},
			validateField() {
				this.errors = [];
				if (this.validationRules && this.validationRules.required && VALIDATION_SERVICE.validateDropdownOptionRequired(this.selectedOption)) {
					this.errors.push(this.$i18n.t('projectFormValidations.isRequired'));
					this.hasError = true;
				} else {
					this.hasError = false;
				}

				this.$emit("hasError", !this.hasError);
			},
			toggleOptionStatus(selectOption) {
				this.optionsList.forEach((element) => element.isSelected = false);
				selectOption.isSelected = !selectOption.isSelected;
			},
			syncOptions() {
				if (this.value && this.optionsList.length) {
					let selectIndex = this.optionsList.findIndex((option) => {
						if (option.id === this.value) {
							return option;
						}
					});
					this.selectedOption = this.optionsList[selectIndex];
					this.toggleOptionStatus(this.optionsList[selectIndex]);
				} else  {
					this.selectedOption = null;
				}
			},
			showErrorFromParent(error) {
				this.parentErrors.push(error);
			},
			clearParentErrors() {
				this.parentErrors = [];
			},
			clearErrors() {
				this.errors = [];
				this.hasError = false;
			}
		},
		watch: {
			options() {
				this.syncOptions();
			},
			value() {
				this.syncOptions();
			}
		},
		computed: {
			optionsList() {
				return this.options;
			},
			activatorClass() {
				if (this.hasError && this.isDisabled) {
					return "has-error disabled";
				} else if (this.hasError) {
					return "has-error";
				} else if (this.parentErrors.length) {
					return "has-error";
				} else if (this.isDisabled) {
					return "disabled";
				}

				return "";
			}
		},
		mounted() {
			document.addEventListener("click", this.checkClick);
			if (this.isManagementListener) {
				EventManagementContent.$on('validateStep', () => {
					this.validateField()
				});
			} else {
				EventStepFrom.$on('validateStep', () => {
					this.validateField()
				});
			}

			this.syncOptions();
		},
		beforeDestroy() {
			document.removeEventListener("click", this.checkClick);
			if (this.isManagementListener) {
				EventManagementContent.$off('validateStep');
			} else {
				EventStepFrom.$off('validateStep');
			}
		}
	}
</script>
<style lang="scss">
.crud-form-group{
	.dropdown-container{
		.dropdown-activator{
			background: #001f33;
			border: 1px solid white;
			.select-label{
				background: #001f33;
			}
		}
		.options-container{
			.dropdown-options{
				.option:nth-child(odd), .option:nth-child(even){
					background: #0D2A3D;
				}
				.option:nth-child(odd):hover, .option:nth-child(even):hover{
					span{
						color:white;
					}
					background: #001f33;
				}

			}
		}


	}
}

</style>
